export const PLAYLIST_ROOT_STATE_URL = '/playlists';
export const MY_PLAYLIST_STATE_URL = '/my-playlists';
export const PLAYLIST_DETAIL_STATE_URL = '/playlists/:playlistId';
export const FEATURED_PLAYLIST_DETAIL_STATE_URL = '/featured-playlist';
